import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { FirebaseAuthProvider } from './context/FirebaseAuthContext';
import { SalesProvider } from './context/SalesContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FirebaseAuthProvider>
      <SalesProvider>
        <App />
      </SalesProvider>
    </FirebaseAuthProvider>
  </React.StrictMode>
);
